// extracted by mini-css-extract-plugin
export default {"tableContainer":"ExportAddressBook_tableContainer__QmrF4","table":"ExportAddressBook_table__Wb3YO","popover":"ExportAddressBook_popover__Y-jZq"};